const isValidLatLong = ({ lat, long } = {}) => typeof lat === 'number' && typeof long === 'number';
const userHasAmexCard = (userData) => {
  const cards = userData?.payment_methods || [];
  return cards.some((card) => card.type === 'amex');
};

export { isValidLatLong, userHasAmexCard };
